import { Check, Moon, Sun } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu'
import { useTheme } from '@/providers/ThemeProvider'

export function ModeToggle() {
  const { theme, setTheme } = useTheme()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="icon" variant="ghost">
          <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
          <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
          <span className="sr-only">Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          className="flex justify-between"
          onClick={() => setTheme('light')}
        >
          <span>Light</span>
          {theme === 'light' && <Check className="w-4 h-4" />}
        </DropdownMenuItem>
        <DropdownMenuItem
          className="flex justify-between"
          onClick={() => setTheme('dark')}
        >
          <span>Dark</span>
          {theme === 'dark' && <Check className="w-4 h-4" />}
        </DropdownMenuItem>
        <DropdownMenuItem
          className="flex justify-between"
          onClick={() => setTheme('system')}
        >
          <span>System</span>
          {theme === 'system' && <Check className="w-4 h-4" />}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
